import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
const Footer = () => {
  const [showScrollBtn, setShowScrollBtn] = useState(false);

  // Show scroll button when user scrolls down 200px
  const handleScroll = () => {
    if (window.scrollY > 200) {
      setShowScrollBtn(true);
    } else {
      setShowScrollBtn(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  const linkVariants4 = {
    hidden: { opacity: 0, y: 20 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.3, // Staggered delay based on index
        type: "spring",
        stiffness: 100,
      },
    }),
    exit:(index)=>({
      opacity:0,
      y:20,
      transition: {
        delay: index*0.5,
        type:"spring",
        stiffness:100,
      }
    })
  };


  return (
    <footer className="relative bg-white z-10 text-yellow-600 py-10">
      {/* Background */}
      <div
        className="absolute inset-0 bg-fixed bg-bottom bg-cover opacity-30"
        style={{
          backgroundImage: "url('../footer3.jpg')",
        }}
      ></div>

      {/* Footer Content */}
      <div className="relative container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
  <h2 className="text-lg font-serif font-bold mb-4">About SnapBucks</h2>
  <p className="text-gray-600 text-sm leading-relaxed">
    At SnapBucks, we are transforming the real estate industry with innovative solutions  
    and an unwavering commitment to excellence. Partner with us to unlock limitless opportunities  
    and secure a prosperous future.
  </p>
</div>


          {/* Links Section */}
          <div>
            <h2 className="text-lg font-serif font-bold mb-4">Quick Links</h2>

            <ul
              className=""
              // initial="hidden"
              // animate="Visible"
              // exit="exit"
            >
              {["Home", "About", "Services", "Projects","Reviews", "Terms","Contact",].map((link, index) => (
                <motion.li
                  key={link}
                  variants={linkVariants4}
                  custom={index}
                  className="text-2xl"
                >
                  <Link to={link === "Home" ? "/" : `/${link.toLowerCase()}`}  className="text-gray-600 hover:text-yellow-600 hover:text-xl transition-all duration-300 text-sm"
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  >

<span className="relative">{link === "Terms" ? "Terms & Conditions" : `${link==="About" ? "About Us" : `${link==="Projects"?"Our Projects":`${link==="Services"?"Our Services":`${link==="Contact"?"Contact Us":`${link==="Reviews"?"Customer Testimonials":`${link==="Team"?"Our Team":`${link}`}`}`}`}`}`}`}</span>
{/* <div className="absolute left-0 bottom-0 w-0 h-1 bg-gradient-to-r from-red-500 to-red-900 rounded group-hover:w-full transition-all duration-500"></div> */}
                  </Link>
                </motion.li>
              ))}
            </ul>

            {/* <ul className="space-y-2">
              {["Home", "About Us", "Services", "Our Clients", "Contact"].map(
                (item, index) => (
                  <li key={index}>
                    <a
                      href={`#${item.replace(/\s+/g, "").toLowerCase()}`}
                      className="text-gray-400 hover:text-red-600 transition-all duration-300 text-sm"
                    >
                      {item}
                    </a>
                  </li>
                )
              )}
            </ul> */}
          </div>

          {/* Contact Section */}
          <div>
            <h2 className="text-lg font-serif font-bold mb-4">Contact Us</h2>
            <p className="text-gray-400 text-sm leading-relaxed">
              Address:{" "}
              <span
                
                className="text-gray-600 hover:text-yellow-600"
              >
                12-6-2/269/4, 2nd Floor, Classic Homes, Kukatpally, Hyderabad - 500072
                
              </span>
            </p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Email:{" "}
              <a
                href="mailto:info@tnrtechnologies.com"
                className="text-gray-600 hover:text-yellow-600"
              >
                spanbucks@gmail.com
                
              </a>
            </p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Phone:{" "}
              <a href="tel:9704503377" className="text-gray-600 hover:text-yellow-600">
                +91 9704503377
              </a>
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-8"></div>

        {/* Social Media Icons */}
        <div className="flex justify-center space-x-6">
          {/* {["facebook", "twitter", "instagram", "linkedin"].map((platform) => (
            <motion.a
              key={platform}
              href={`https://${platform}.com`}
              className="text-gray-400 hover:text-re-600 text-2xl transition-all duration-300"
              whileHover={{ scale: 1.2 }}
            >
              <i className={`fab fa-${platform}`}></i>
            </motion.a>
          ))} */}
          <motion.a
              
              href={`https://www.facebook.com/profile.php?id=61575100950518`}
              className="text-gray-600 hover:text-yellow-600 text-2xl transition-all duration-300"
              whileHover={{ scale: 1.2 }}
              target="blank"

            >
              <i className={`fab fa-facebook`}></i>
            </motion.a>
            <motion.a
              
              href={`https://www.instagram.com/spanbucks?igsh=dnNvOG92MWZwMjIw`}
              className="text-gray-600 hover:text-yellow-600 text-2xl transition-all duration-300"
              whileHover={{ scale: 1.2 }}
              target="blank"
            >
              <i className={`fab fa-instagram`}></i>
            </motion.a>
            <motion.a
              
              href={`https://wa.me/9704503377?text=Hi%20there!%20I%20would%20like%20to%20know%20more%20about%20your%20projects.`}
              className="text-gray-600 hover:text-yellow-600 text-2xl transition-all duration-300"
              whileHover={{ scale: 1.2 }}
              target="blank"

            >
              <FaWhatsapp />
            </motion.a>
            <motion.a
              
              href={`https://youtube.com/@spanbucks?si=cInHK2nT__lgpH43`}
              className="text-gray-600 hover:text-yellow-600 text-2xl transition-all duration-300"
              whileHover={{ scale: 1.2 }}
              target="blank"

            >
              <i className={`fab fa-youtube`}></i>
            </motion.a>
            
            <motion.a
              
              href={`https://www.linkedin.com/company/spanbucks-developers-and-builders-private-limited/`}
              className="text-gray-600 hover:text-yellow-600 text-2xl transition-all duration-300"
              whileHover={{ scale: 1.2 }}
              target="blank"

            >
              <i className={`fab fa-linkedin`}></i>
            </motion.a>
            
            <motion.a
              
              href={`https://x.com/SpanBucks?t=8LeNzK9QNXLPrLwm3YQecQ&s=09`}
              className="text-gray-600 hover:text-yellow-600 text-2xl transition-all duration-300"
              whileHover={{ scale: 1.2 }}
              target="blank"

            >
              <FaXTwitter />
            </motion.a>
        </div>

        {/* Footer Bottom */}
        <div className="text-center text-gray-600 text-sm mt-6">
          &copy; {new Date().getFullYear()} SPANBUCKS. All rights
          reserved.
        </div>
      </div>

      {/* Scroll to Top Button */}
      {showScrollBtn && (
        <motion.div
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.8 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 bg-yellow-600 hover:bg-transparent hover:border hover:border-yellow-500 text-white rounded-full p-4 shadow-xl cursor-pointer transform transition-all duration-500 hover:scale-110"
        >
          {/* Rotating and moving arrow icon */}
          <motion.i
            className="fas fa-arrow-up text-lg"
            whileHover={{ y: -10 }}  // Moves the arrow up when hovered
            transition={{ type: "spring", stiffness: 300, duration:0.5 }}
            
          ></motion.i>
        </motion.div>
      )}
    </footer>
  );
};

export default Footer;
